<template>
  <div class="box">
    <div class="btn" @click="exportData(activeName)">
      <img src="../../assets/serach/export.svg" alt="" />
      导出
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="switch-tab">
      <el-tab-pane label="实时库存" name="first">
        <el-table
          ref="singleTable"
          :data="tableData"
          stripe
          width="200"
          max-height="650px"
          style="width: 100%"
          show-summary
          :summary-method="getSummaries"
          highlight-current-row
        >
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column prop="warehouseNo" label="入库单号" width="150"> </el-table-column>
          <el-table-column prop="batchNo" label="批次号" width="150"> </el-table-column>
          <el-table-column prop="produceCode" label="商品编码" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column prop="produceDesc" label="商品描述" show-overflow-tooltip width="200">
          </el-table-column>
          <el-table-column prop="warehouseName" label="仓库名称" show-overflow-tooltip width="200">
          </el-table-column>
          <el-table-column
            prop="financialInventoryBalance"
            label="财务库存余额"
            show-overflow-tooltip
            width="150"
            :formatter="formatterNum"
          >
          </el-table-column>
          <el-table-column prop="inWarehouseNum" label="入库数量" show-overflow-tooltip width="150">
            <template slot-scope="scope">
              {{ number_format(Number(scope.row.outWarehouseNum), 0, '.', ',') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="outWarehouseNum"
            label="出库数量"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              {{ number_format(Number(scope.row.outWarehouseNum), 0, '.', ',') }}
            </template>
          </el-table-column>
          <el-table-column prop="serviceNum" label="业务可用数量" show-overflow-tooltip width="150">
            <template slot-scope="scope">
              <span v-if="Number(scope.row.serviceNum) === 0" style="color: red">
                {{ number_format(Number(scope.row.serviceNum), 0, '.', ',') }}
              </span>
              <span v-else style="color: #00b400">
                {{ number_format(Number(scope.row.serviceNum), 0, '.', ',') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="warehouseAmount"
            label="库存金额"
            show-overflow-tooltip
            width="150"
            :formatter="formatterNum"
          >
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            label="单价"
            show-overflow-tooltip
            width="150"
            :formatter="formatterNum"
          >
          </el-table-column>
          <el-table-column
            prop="deliveredCost"
            label="已发货成本"
            show-overflow-tooltip
            width="150"
            :formatter="formatterNum"
          >
          </el-table-column>
          <el-table-column prop="warehouseType" label="入库类型" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div class="block">
          <div class="left"
            >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
            {{ (page.pageNum - 1) * page.pageSize + page.pageSize }} 条记录，共
            {{ page.total }} 条记录</div
          >
          <el-pagination
            class="right"
            ref="page"
            background
            @size-change="handleSizeChange"
            @current-change="handlePagination"
            :page-count="page.pages"
            :current-page="page.pageNum || 1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.total"
            layout="sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="库存明细" name="second">
        <el-table
          ref="singleTable"
          :data="logisticsData"
          stripe
          width="200"
          max-height="650px"
          style="width: 100%"
          show-summary
          :summary-method="getSummaries"
          highlight-current-row
        >
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column prop="billNo" label="单据号"> </el-table-column>
          <el-table-column prop="billType" label="单据类型"> </el-table-column>
          <el-table-column prop="batchNo" label="批次号" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="businessDate" label="业务日期" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="inWarehouseNum"
            label="入库数量"
            show-overflow-tooltip
            :formatter="formatterNum"
          >
          </el-table-column>
          <el-table-column
            prop="outWarehouseNum"
            label="出库数量"
            show-overflow-tooltip
            :formatter="formatterNum"
          >
          </el-table-column>
        </el-table>
        <div class="block">
          <div class="left"
            >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
            {{ (page.pageNum - 1) * page.pageSize + page.pageSize }} 条记录，共
            {{ page.total }} 条记录</div
          >
          <el-pagination
            class="right"
            ref="page"
            background
            @size-change="handleSizeChange"
            @current-change="handlePagination"
            :page-count="page.pages"
            :current-page="page.pageNum || 1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.total"
            layout="sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  // import tableData from './mockData';
  export default {
    name: 'logisticsStock',
    data() {
      return {
        activeName: 'first',
        tableData: [],
        menuButtonList: [],
        logisticsData: [],
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
      };
    },
    mounted() {
      this.getButtonList();
      this.loadTableData();
    },
    methods: {
      async loadTableData() {
        let data = await this.$baseRequest.getCenterList({
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        });
        this.tableData = data.list;
        this.page.total = data.total;
      },
      async loadLogisticsData() {
        let data = await this.$baseRequest.getLogisticsList({
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        });
        this.logisticsData = data.list;
        this.page.total = data.total;
      },
      async exportData(type) {
        let url = '';
        if (type === 'first') {
          url = await this.$baseRequest.exportStock({});
        } else {
          url = await this.$baseRequest.exportLogistics({});
        }
        window.location.href = url;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      handleClick() {
        this.page.pageNum = 1;
        switch (this.activeName) {
          case 'first':
            this.loadTableData();
            break;
          case 'second':
            this.loadLogisticsData();
            break;
        }
      },
      //抛出选择每页条数事件
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        switch (this.activeName) {
          case 'first':
            this.loadTableData();
            break;
          case 'second':
            this.loadLogisticsData();
            break;
        }
      },
      //抛出当前页数跳转事件
      handlePagination(val) {
        this.page.pageNum = val;
        switch (this.activeName) {
          case 'first':
            this.loadTableData();
            break;
          case 'second':
            this.loadLogisticsData();
            break;
        }
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          if (index === 1) {
            sums[index] = '';
            return;
          }
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            let total = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = this.number_format(total, 3, '.', ',');
          } else {
            sums[index] = '';
          }
        });
        return sums;
      },
      formatterNum(row, column) {
        // const formatPrice = (number) => {
        //   number = '' + number
        //
        //   const [ integer, decimal = '' ] = number.split('.')
        //
        //   return integer.replace(/\B(?=(\d{3})+$)/g, ',') + (decimal ? '.' + decimal : '')
        // }
        return this.number_format(row[column.property], 2, '.', ',');
      },
      number_format(number, decimals, dec_point, thousands_sep) {
        /*
         * 参数说明：
         * number：要格式化的数字
         * decimals：保留几位小数
         * dec_point：小数点符号
         * thousands_sep：千分位符号
         * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
          prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
          sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
          dec = typeof dec_point === 'undefined' ? '.' : dec_point,
          s = '',
          toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
          };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
          s[0] = s[0].replace(re, '$1' + sep + '$2');
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    background-color: #ffffff;
    padding: 20px 30px;
    position: relative;
    .switch-tab {
      ::v-deep .el-tabs__content {
        border: 1px solid #f8f8f8;
      }
      ::v-deepep .el-table__header-wrapper {
        .el-table__cell {
          background-color: #323233;
          color: #ffffff;
        }
      }
      ::v-deepep .el-tabs__nav-wrap::after {
        display: none;
      }
      ::v-deepep .el-tabs__item {
        color: #000000;
      }
      ::v-deepep .el-tabs__active-bar {
        background-color: #409eff;
      }
      .block {
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        font-size: 12px;
      }
    }
    .btn {
      cursor: pointer;
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #409eff;
      color: #ffffff;
      position: absolute;
      right: 30px;
      top: 30px;
      border-radius: 3px;
      z-index: 99;
      img {
        vertical-align: middle;
        padding-right: 6px;
      }
    }
  }
</style>
